import React from "react";
import { useSelector } from "react-redux";

const CommunityImage = ({ imageList }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	// const user = useSelector(state => state.auth.user);
	// let imageUserId = {
	//     ...reduxChannel,
	//     user_id
	// }
	// const userId = (user?.role === "level_1" || user?.role === "super_admin") ? user?.id : user?.partners_id;
	// console.log(reduxChannel, userId);
	// console.log(`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id === 1 ? imageList[0}?.influencer_id : reduxChannel?.user_id/${imageList[0]?.title}.${imageList[0]?.img_type}`);
	console.log("adsada", imageList, reduxChannel);
	if (imageList?.length > 3) {
		return (
			<>
				<div className={`community-image-group`}>
					<div className={`community-image-big`}>
						<img
							src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${
								reduxChannel?.user_id === 1
									? imageList[0]?.influencer_id
									: reduxChannel?.user_id
							}/${imageList[0]?.title}.${imageList[0]?.img_type}`}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/no-product.png`;
							}}
							alt={`게시판 이미지`}
						/>
					</div>
					<div className={`community-image-many`}>
						<img
							className={`image-each`}
							src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${
								reduxChannel?.user_id === 1
									? imageList[1]?.influencer_id
									: reduxChannel?.user_id
							}/${imageList[1]?.title}.${imageList[1]?.img_type}`}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/no-product.png`;
							}}
							alt={`게시판 이미지`}
						/>
						<img
							className={`image-each`}
							src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${
								reduxChannel?.user_id === 1
									? imageList[2]?.influencer_id
									: reduxChannel?.user_id
							}/${imageList[2]?.title}.${imageList[2]?.img_type}`}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/no-product.png`;
							}}
							alt={`게시판 이미지`}
						/>
						<div className={`image-each`}>
							<img
								src={`${
									process.env.REACT_APP_S3_HOST
								}/image/together/community/${
									reduxChannel?.user_id === 1
										? imageList[3]?.influencer_id
										: reduxChannel?.user_id
								}/${imageList[3]?.title}.${imageList[3]?.img_type}`}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null; // prevents looping
									// currentTarget.style.display = "none";
									currentTarget.src = `/assets/images/no-product.png`;
								}}
								alt={`게시판 이미지`}
								style={{ filter: "brightness(0.5)" }}
							/>
							<p>더보기</p>
						</div>
					</div>
				</div>
			</>
		);
	} else {
		return (
			<div
				className={`home-community-image home-mobile-image-group image-list-group`}
			>
				{/*{mediaResult ? (*/}
				<>
					{/* eslint-disable-next-line array-callback-return */}
					{imageList?.map((img, index) => {
						if (index < 3)
							return (
								<div
									className={`mobile-community-image`}
									key={`list-img-${index}`}
									style={
										imageList?.length === 3
											? {
													width: "32%",
											  }
											: imageList?.length === 2
											? {
													width: "49%",
											  }
											: imageList?.length === 1
											? {
													width: "100%",
											  }
											: {
													display: "none",
											  }
									}
								>
									<img
										src={`${
											process.env.REACT_APP_S3_HOST
										}/image/together/community/${
											reduxChannel?.user_id === 1
												? img?.influencer_id
												: reduxChannel?.user_id
										}/${img?.title}.${img?.img_type}`}
										onError={({ currentTarget }) => {
											currentTarget.onerror = null; // prevents looping
											// currentTarget.style.display = "none";
											currentTarget.src = `/assets/images/no-product.png`;
										}}
										alt={`게시판 이미지`}
										style={
											index === 2
												? {
														filter: "brightness(0.5)",
														height: "100%",
														width: "100%",
												  }
												: {
														height: "100%",
														width: "100%",
												  }
										}
									/>
									{index === 2 && <p>더보기</p>}
								</div>
							);
					})}
				</>
			</div>
		);
	}
};
export default CommunityImage;
